import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _empty = {};
var _getReactionsRequest = {};
var _getReactionsResponse = { itemReactions: '_itemReactionsSummary' };
var _getReactionsSummaryRequest = {};
var _getReactionsSummaryResponse = { reactionsSummary: '_reactionsSummary' };
var _getRequest = {};
var _itemReactionsSummary = {
    usersReactions: '_usersReactions',
    reactionsSummary: '_reactionsSummary',
};
var _reactionsSummary = { latestReactions: '_reactionSummary' };
var _reactionSummary = { reactionTime: 'google.protobuf.Timestamp' };
var _reactRequest = {};
var _removeAllRequest = {};
var _unreactRequest = {};
var _userReaction = { reactionTime: 'google.protobuf.Timestamp' };
var _usersReactions = { userReactions: '_userReaction' };
function resolveWixReactionsReactionsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/reactions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** react on an item */
export function react(payload) {
    return function __react(_a) {
        var host = _a.host;
        var toJSON = serializer(_reactRequest, {}).toJSON;
        var fromJSON = serializer(_itemReactionsSummary, {
            _reactionSummary: _reactionSummary,
            _reactionsSummary: _reactionsSummary,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions/{itemId}/react',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** react on an item */
export function unreact(payload) {
    return function __unreact(_a) {
        var host = _a.host;
        var toJSON = serializer(_unreactRequest, {}).toJSON;
        var fromJSON = serializer(_itemReactionsSummary, {
            _reactionSummary: _reactionSummary,
            _reactionsSummary: _reactionsSummary,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions/{itemId}/unreact',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** get reactions */
export function get(payload) {
    return function __get(_a) {
        var host = _a.host;
        var toJSON = serializer(_getRequest, {}).toJSON;
        var fromJSON = serializer(_itemReactionsSummary, {
            _reactionSummary: _reactionSummary,
            _reactionsSummary: _reactionsSummary,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** remove reactions */
export function removeAll(payload) {
    return function __removeAll(_a) {
        var host = _a.host;
        var toJSON = serializer(_removeAllRequest, {}).toJSON;
        var fromJSON = serializer(_empty, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions/{itemId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** get reactions */
export function getReactions(payload) {
    return function __getReactions(_a) {
        var host = _a.host;
        var toJSON = serializer(_getReactionsRequest, {}).toJSON;
        var fromJSON = serializer(_getReactionsResponse, {
            _itemReactionsSummary: _itemReactionsSummary,
            _reactionSummary: _reactionSummary,
            _reactionsSummary: _reactionsSummary,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** get reactions */
export function getOwnReactions(payload) {
    return function __getOwnReactions(_a) {
        var host = _a.host;
        var toJSON = serializer(_getReactionsRequest, {}).toJSON;
        var fromJSON = serializer(_getReactionsResponse, {
            _itemReactionsSummary: _itemReactionsSummary,
            _reactionSummary: _reactionSummary,
            _reactionsSummary: _reactionsSummary,
            _userReaction: _userReaction,
            _usersReactions: _usersReactions,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions/own',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** get summary */
export function getReactionsSummary(payload) {
    return function __getReactionsSummary(_a) {
        var host = _a.host;
        var toJSON = serializer(_getReactionsSummaryRequest, {}).toJSON;
        var fromJSON = serializer(_getReactionsSummaryResponse, {
            _reactionSummary: _reactionSummary,
            _reactionsSummary: _reactionsSummary,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixReactionsReactionsServiceUrl({
                protoPath: '/api/v1/reactions/summary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map